import { DrawingBasketDto } from "./drawing-basket.dto";

export class DrawingEuroPlayoffBaskets {
    championsLeagueBasket: DrawingBasketDto;
	euroLeagueBasket: DrawingBasketDto;
	conferenceLeagueBasket: DrawingBasketDto;
}